import { Directive, Input, HostListener, ElementRef, Renderer2 } from '@angular/core';
import { ConfigService } from '../services/config.service';
import { ProcessTypeFeatureFlags } from '../models/process-type-feature-flags.enum';

@Directive({
  selector: '[feature]'
})
export class ProcessTypeFeatureDirective {
  
  @Input() set feature(f: ProcessTypeFeatureFlags){
    this._feature = f;
    if(!this.configService.isFeatureEnabled(f)){
      Array.from(this.element.nativeElement.children).forEach(el => {
        this.renderer.setAttribute(el, 'disabled', 'true')
      })
      this.popup = this.renderer.createElement('div');
      this.renderer.addClass(this.popup, "blockedpopup")
      let text = this.renderer.createText(this.configService.configData.blockedFeatureMessage);
      this.renderer.appendChild(this.popup, text)
    }
  };

  private _feature: ProcessTypeFeatureFlags;
  private popup: any;

  constructor(
    private element: ElementRef,
    private configService: ConfigService, 
    private renderer : Renderer2) { }
  

  @HostListener('mouseenter') onMouseEnter() {
    if(this._feature && !this.configService.isFeatureEnabled(this._feature)){
      this.renderer.appendChild(this.element.nativeElement, this.popup)
    }
  }
  @HostListener('mouseleave') onMouseLeave() {
    if(this._feature && !this.configService.isFeatureEnabled(this._feature)){
      this.renderer.removeChild(this.element.nativeElement, this.popup)
    }
  }

}
